module.exports = __webpack_public_path__ + "media/images/img/tag_company/future_tag-89c1f6ae5a6abffec37afc7c908cfdf6.png";